export default __webpack_public_path__ + "static/Scroll-Image---Propane-Tank-Removal-1ddf220cedc8d37ea741bd3999b63abf.jpg";